<app-modal-basic #modal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" class="close basic-close" (click)="hideModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form #manageUser [formGroup]="classicForm">
      <formly-form  [model]="lastValue" [fields]="manageUserForm"  [options]="options" [form]="classicForm">
      </formly-form>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="hideModal()">{{'global.cancel'|translate}}</button>
    <button class="btn btn-primary ripple light" type="button" [disabled]="!classicForm.valid" (click)="saveUser()">
      {{(isEdit ? 'global.actions.save' : 'global.actions.add') | translate}}
    </button>
  </div>
</app-modal-basic>
